import { inject, Injectable } from '@angular/core';
import { DriveItemType, DriveOdataItem } from '@common/models';
import { I18NextPipe } from 'angular-i18next';
import { I18_NAMESPACE_APPS_UI } from 'i18n';
import { TableHeader } from 'mbs-ui-kit';

@Injectable()
export class DriveTableHelperService {
  private readonly i18nPipe = inject(I18NextPipe);

  protected readonly moduleDrive = I18_NAMESPACE_APPS_UI.drive;

  filterDriveByClassNameFolder(item: DriveOdataItem): boolean {
    return item.Type == DriveItemType.Folder;
  }

  getTableHeaders(jumpToFile = false): TableHeader[] {
    const columns: TableHeader[] = [
      {
        name: this.i18nPipe.transform(this.moduleDrive + ':grid.type', { format: 'capitalize' }),
        gridColMin: '63px',
        gridColSize: '63px',
        class: '-center',
        sort: 'Type'
      },
      {
        name: this.i18nPipe.transform(this.moduleDrive + ':grid.name', { format: 'capitalize' }),
        gridColMin: '150px',
        gridColSize: '20fr',
        overflow: true,
        class: 'text-overflow',
        sort: 'Name'
      },
      {
        name: this.i18nPipe.transform(this.moduleDrive + ':grid.size', { format: 'capitalize' }),
        gridColMin: '84px',
        gridColSize: '10fr',
        headerClass: '-right',
        class: 'text-overflow -right',
        sort: 'Size'
      }
    ];

    if (jumpToFile) {
      columns.push({
        name: '',
        gridColMin: '46px',
        gridColSize: '46px',
        class: '-stretch'
      });
    }

    return columns;
  }
}
